import { pushDigitalData, changesDigitalData } from '@/utils/digitalData';
import { getLineItemsBasket } from '@/utils/formatters/formattedDigitalDataManager';

const useCart = () => {
  // const { $config } = useContext();

  // TODO: перенос
  const getLineItems = basketItem => basketItem.map(item => getLineItemsBasket(item, {}));

  const updateCart = (cartInfo) => {
    pushDigitalData({
      category: 'Ecommerce',
      name: 'Updated Cart',
      cart: {
        checkoutType: '5-step',
        currency: 'RUB',
        id: String(cartInfo.id),
        lineItems: getLineItems(cartInfo.basketItem),
        subtotal: Number(cartInfo.amount.total),
        total: Number(cartInfo.amount.discounted),
      },
    });
  };

  const setCart = (cartInfo) => {
    changesDigitalData(['cart', {
      checkoutType: '5-step',
      currency: 'RUB',
      id: String(cartInfo.id),
      lineItems: getLineItems(cartInfo.basketItem),
      subtotal: Number(cartInfo.amount.total),
      total: Number(cartInfo.amount.discounted),
    }, 'book24']);
  };

  const resetCart = () => {
    changesDigitalData(['cart', {
      checkoutType: '5-step',
      currency: 'RUB',
      lineItems: [],
      subtotal: 0,
      total: 0,
    }, 'book24']);
  };

  return { updateCart, setCart, resetCart };
};

export default useCart;
